<div>
  <mat-card appearance="outlined" class="pad10">
    <div id="jobDesc_mat-card-div">
      <h4 class="h4Header GreyDarkest text-1line" style="padding: 10px" id="jobDesc_mat-card-h4">Attach Resume</h4>
    </div>
    <div name="attachment">
      <mat-card-content>
        <mat-chip-listbox class="">
          <mat-chip-option class="chipStyle-Normal marR16" *ngFor="let file of editFileNameArray1">
            <a
              href="javascript:void();"
              class="icon x-16 icon-close-mini chipIconRight"
              (click)="removeEditParent($event, file.fileID)"
            ></a>
            <a
              href="javascript:void();"
              style="color: black; text-decoration: none"
              (click)="downloadFile(file.fileID)"
            >
              {{ file.fileName }}
            </a>
          </mat-chip-option>
          <mat-chip-option class="chipStyle-Normal marR16" *ngFor="let file of fileNameArray">
            <a
              href="javascript:void();"
              class="icon x-16 icon-close-mini chipIconRight"
              (click)="removeParent($event, file)"
            ></a>
            <span class="truncate-chip-text" [title]="file">{{ file }}</span>
          </mat-chip-option>
        </mat-chip-listbox>
      </mat-card-content>
      <hr *ngIf="!viemMode" />

      <button *ngIf="!viemMode" mat-flat-button name="addAttach" class="Icon-Btn" (click)="openDialog()">
        <img
          class="add_attach"
          id="addAttachicon"
          alt="icon-add"
          src="assets/images/icons/purple_icons/icon-add-dark.png"
        />
        <span name="addAttachText">Upload Resume</span>
      </button>
    </div>
  </mat-card>
</div>
